import React from 'react';
import './TitlePage.scss'

interface TitlePageProps {
  title: string;
  medium?: boolean,
  style?: object
}

const TitlePage = ({
  title,
  medium = false, 
  style = {}
}: TitlePageProps): JSX.Element => {
  return (
    <>
      {
        medium ?
          <h2 className={`title-page_medium`} style={style}>{title}</h2>
          :
          <h1 className={`title-page`} style={style}>{title}</h1>
      }
    </>
  )
};

export { TitlePage };